import { useFormContext } from 'react-hook-form'
import type { z } from 'zod'
import { ShellPartialFormSchema, ShellUpgradeFormSchema } from '../form-schemas'

export const useExperienceShellFormContext = (isUpgrade: boolean) => {
	const schema = isUpgrade ? ShellUpgradeFormSchema : ShellPartialFormSchema
	return useFormContext<z.infer<typeof schema>>()
}
